module.exports = __webpack_public_path__ + "static/media/starship3.89922ffe.png";